export default "__VITE_ASSET__fylO05Yn__"